import { lazy, Suspense } from 'react'
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom'
import { Navigation } from './components/Navigation'
import { PageOverlay } from './components/PageOverlay'
import { BackToTop } from './components/BackToTop'
import { Footer } from './sections/Footer'
import { usePageLoad } from './hooks/usePageLoad'
import { usePublicAnalytics } from './hooks/usePublicAnalytics'
import './App.css'

const ChatWidget = lazy(() =>
  import('./components/ChatWidget').then((m) => ({ default: m.ChatWidget }))
)
const NewsletterNudge = lazy(() =>
  import('./components/NewsletterNudge').then((m) => ({ default: m.NewsletterNudge }))
)

function App() {
  const { showOverlay } = usePageLoad()
  const location = useLocation()
  const isAdmin = location.pathname.startsWith('/admin')
  usePublicAnalytics()

  if (isAdmin) {
    return (
      <>
        <Outlet />
        <ScrollRestoration />
      </>
    )
  }

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-md focus:bg-accent-blue focus:text-accent-fg focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-blue focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--color-bg)]"
      >
        Skip to content
      </a>
      <PageOverlay isVisible={showOverlay} />
      <Navigation />
      <main id="main-content" className="min-h-screen bg-surface-elevated">
        <Outlet />
      </main>
      <Footer />
      <Suspense fallback={null}>
        <ChatWidget />
        <NewsletterNudge />
      </Suspense>
      <BackToTop />
      <ScrollRestoration />
    </>
  )
}

export default App
